import { createFileRoute } from "@tanstack/react-router";
import { PublicReview } from "@/pages/PublicReview";

/**
 * Bewusst **außerhalb** von `_angemeldet` — wie `/drehplan/$token`: Das
 * Review geht an Kunden und Agentur-Endkunden OHNE Konto. Der lange,
 * serverseitig vergebene Token in der Adresse ist der Zugang; die
 * Datengrenze hält das Backend (nur offene Inhalte, keine internen Felder).
 */
export const Route = createFileRoute("/review/$token")({
	component: ReviewSeite,
});

function ReviewSeite() {
	const { token } = Route.useParams();
	return <PublicReview token={token} />;
}
